import { Zap } from "lucide-react";

const scrollToBuy = () => {
  const el = document.getElementById("buy");
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 border-b border-zinc-800 bg-zinc-950/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-3.5 sm:px-8">
        <a
          href="/"
          data-testid="logo-link"
          className="flex items-center gap-2 group"
        >
          <span className="flex h-8 w-8 items-center justify-center border border-blaze bg-blaze/10 transition-colors group-hover:bg-blaze">
            <Zap className="h-4 w-4 text-blaze transition-colors group-hover:text-black" fill="currentColor" />
          </span>
          <span className="font-display text-2xl tracking-tight leading-none">
            OVERCLOCK
          </span>
        </a>

        <div className="hidden items-center gap-6 md:flex">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
            Functional Mushroom Coffee
          </span>
        </div>

        <button
          data-testid="header-shop-btn"
          onClick={scrollToBuy}
          className="group flex items-center gap-2 border border-blaze bg-blaze px-4 py-2 font-mono text-[11px] font-semibold uppercase tracking-[0.15em] text-black transition-transform duration-200 hover:-translate-y-0.5 hover:translate-x-0.5"
        >
          Shop Now
          <Zap className="h-3.5 w-3.5" fill="currentColor" />
        </button>
      </div>
    </header>
  );
};
